module.exports = __webpack_public_path__ + "static/media/translate-IPhone.acf13b53.png";